export default __webpack_public_path__ + "static/media/popup.42e863d9.png";